// 转盘和翻牌共用的多语言文案
const langFiles = (require as any).context('./locale', false, /\.ts$/);

const textLang: Record<string, Record<string, any>> = {};
langFiles.keys().forEach((filePath: string) => {
    const fileName = filePath.replace(/^\.\/(.*)\.ts$/, '$1');
    textLang[fileName] = langFiles(filePath).default;
});

export { textLang };
